import { Reducer } from 'redux'
import { PaymentPagesState, PaymentPagesTypes } from './types'
import { AuthActionTypes } from '../auth'

export const initialState: PaymentPagesState = {
  error: undefined,
  pagesError: undefined,
  paymentPageError: undefined,
  pageTransactionsError: undefined,
  failure: false,
  loading: false,
  pages: [],
  pagesReport: null,
  pagesTotal: 0,
  success: false,
  isSubmitting: false,
  singlePage: undefined,
  pageTransactions: [],
  pageTransactionsReport: null,
  pageTransactionsTotal: 0,
  fee: undefined,
  feeError: undefined,
  feeLoading: false,
  providers: []
}

const reducer: Reducer<PaymentPagesState> = (state = initialState, action) => {
  switch (action.type) {
    case AuthActionTypes.DESTROY_STATES:
      return initialState

    case PaymentPagesTypes.ADD_PAYMENT_PAGE_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        error: {},
        success: false,
        failure: false
      }
    case PaymentPagesTypes.ADD_PAYMENT_PAGE_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        error: {},
        pages: [action.payload, ...state.pages],
        success: true,
        failure: false
      }
    case PaymentPagesTypes.ADD_PAYMENT_PAGE_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error: action.payload,
        success: false,
        failure: true
      }

    case PaymentPagesTypes.UPDATE_PAYMENT_PAGE_REQUEST:
      return {
        ...state,
        isSubmitting: true
      }

    case PaymentPagesTypes.UPDATE_PAYMENT_PAGE_SUCCESS:
      let pages = state.pages.slice()
      pages = pages.filter(
        (page) => page.paymentPageId !== action.payload.paymentPageId
      )
      pages.unshift(action.payload)
      return {
        ...state,
        isSubmitting: false,
        pages: pages,
        success: true,
        failure: false
      }

    case PaymentPagesTypes.UPDATE_PAYMENT_PAGE_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error: action.payload,
        success: false,
        failure: true
      }

    case PaymentPagesTypes.DELETE_PAYMENT_PAGE_REQUEST:
      return {
        ...state,
        isSubmitting: true
      }

    case PaymentPagesTypes.DELETE_PAYMENT_PAGE_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        success: true,
        failure: false,
        pages: state.pages.filter(
          (page) => page.paymentPageId !== action.payload
        )
      }

    case PaymentPagesTypes.DELETE_PAYMENT_PAGE_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        success: false,
        failure: true,
        error: action.payload
      }

    case PaymentPagesTypes.GET_PAYMENT_PAGES_REQUEST:
      return {
        ...state,
        loading: true,
        pages: [],
        pagesReport: null,
        pagesTotal: 0,
        pagesError: undefined
      }

    case PaymentPagesTypes.GET_PAYMENT_PAGES_SUCCESS:
      const pagesReport = action.payload
      const paymentPages = pagesReport.records || pagesReport.Records || []
      const pagesSummary = pagesReport.summary || pagesReport.Summary
      return {
        ...state,
        loading: false,
        pagesReport,
        pages: paymentPages,
        pagesError: undefined,
        pagesTotal:
          pagesSummary?.recordsTotal ??
          pagesSummary?.RecordsTotal ??
          paymentPages.length
      }

    case PaymentPagesTypes.GET_PAYMENT_PAGES_FAILURE:
      return {
        ...state,
        loading: false,
        pages: [],
        pagesReport: null,
        pagesTotal: 0,
        pagesError: action.payload
      }

    case PaymentPagesTypes.PAYMENT_PAGE_REQUEST:
      return {
        ...state,
        loading: true,
        paymentPageError: undefined
      }

    case PaymentPagesTypes.PAYMENT_PAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        singlePage: action.payload,
        paymentPageError: undefined
      }

    case PaymentPagesTypes.PAYMENT_PAGE_FAILURE:
      return {
        ...state,
        loading: false,
        paymentPageError: action.payload
      }

    case PaymentPagesTypes.GET_PAGE_TRANX_REQUEST:
      return {
        ...state,
        loading: true,
        pageTransactions: [],
        pageTransactionsReport: null,
        pageTransactionsTotal: 0,
        pageTransactionsError: undefined
      }

    case PaymentPagesTypes.GET_PAGE_TRANX_SUCCESS:
      const pageTransactionsReport = action.payload
      const pageTransactions =
        pageTransactionsReport.records || pageTransactionsReport.Records || []
      const pageTransactionsSummary =
        pageTransactionsReport.summary || pageTransactionsReport.Summary
      return {
        ...state,
        loading: false,
        pageTransactionsReport,
        pageTransactions,
        pageTransactionsError: undefined,
        pageTransactionsTotal:
          pageTransactionsSummary?.recordsTotal ??
          pageTransactionsSummary?.RecordsTotal ??
          pageTransactions.length
      }

    case PaymentPagesTypes.GET_PAGE_TRANX_FAILURE:
      return {
        ...state,
        loading: false,
        pageTransactions: [],
        pageTransactionsReport: null,
        pageTransactionsTotal: 0,
        pageTransactionsError: action.payload
      }

    case PaymentPagesTypes.CLEAR_STATES:
      return {
        ...state,
        isSubmitting: false,
        error: undefined,
        pagesError: undefined,
        paymentPageError: undefined,
        pageTransactionsError: undefined,
        success: false,
        failure: false
      }
    case PaymentPagesTypes.CLEAR_PAYMENT_PAGES:
      return {
        ...state,
        pages: []
      }
    case PaymentPagesTypes.REQUEST_FEE_REQUEST:
      return {
        ...state,
        feeError: initialState.feeError,
        feeLoading: true
      }

    case PaymentPagesTypes.REQUEST_FEE_SUCCESS:
      return {
        ...state,
        fee: action.payload,
        feeLoading: false
      }

    case PaymentPagesTypes.REQUEST_FEE_FAILURE:
      return {
        ...state,
        feeError: action.payload,
        feeLoading: false
      }
    case PaymentPagesTypes.CLEAR_FEE:
      return {
        ...state,
        fee: undefined
      }

    case PaymentPagesTypes.GET_PROVIDERS_SUCCESS:
      return {
        ...state,
        providers: action.payload
      }

    case PaymentPagesTypes.GET_PROVIDERS_FAILURE:
      return {
        ...state,
        error: action.payload
      }

    default:
      return state
  }
}

export { reducer as paymentPagesReducer }
